import initCarousel from "common/carousel";
import initStatements from "ui/statements";
import initResources from "ui/resources";
import initResetPassword from "ui/reset-password";

import "styles/site.scss";

$(function () {
    initCarousel();
    initStatements();
    initResources();
    initResetPassword();
});
